import axios from "axios";
import {
  homeLinksRequested,
  homeLinksRequestSucceeded,
  homeLinksRequestFailed,
} from "../slices/GetHomeLinksByCountrySlice";
//const selectedCountry = localStorage.getItem("selectedCountry");

/* const apiUrl = `${
  process.env.REACT_APP_BASE_API_URL
}/api/Category/GetActivesByCountry?countryName=${encodeURIComponent(
  selectedCountry
)}`; */
const apiUrl = `${process.env.REACT_APP_BASE_API_URL}/api/Home/GetAllHomeLinks`;

const ApiKey = process.env.REACT_APP_BASE_API_KEY;

export const getHomeLinksByCountry = () => async (dispatch) => {
  try {
    dispatch(homeLinksRequested());

    const axiosConfig = {
      headers: {
        ApiKey: ApiKey,
        "Content-Type": "application/json",
      },
    };

    const response = await axios.get(apiUrl, axiosConfig);

    dispatch(homeLinksRequestSucceeded(response.data));
  } catch (error) {
    dispatch(homeLinksRequestFailed(error.message));
  }
};
